export const isTesting = () => {
  return (
    process.env.REACT_APP_ENVIRONMENT === 'testing' ||
    process.env.REACT_APP_ENV === 'staging'
  )
}
